import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
export const ReviewHero = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <div className="py-20">
      <div className="container mx-auto flex flex-col items-center">
        <div className="lg:w-1/2 text-center px-3 lg:px-1">
          <h1 className="lg:text-4xl text-lg whitespace-nowrap text-black font-semibold">
            Our Client’s
            <span className="text-gradient-purple lg:text-5xl text-xl">
              Trust with US!
            </span>
          </h1>
          {/* excelent */}
          <div className="flex justify-center pt-8">
            <div className="w-[70%]">
              {theme === "glassy" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./excelent.png"
                    alt="clients"
                  />
                </div>
              ) : theme === "light" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./light-theme.png"
                    alt="clients"
                  />
                </div>
              ) : theme === "dark" ? (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./dark-theme.png"
                    alt="clients"
                  />
                </div>
              ) : (
                <div className="w-full">
                  <StaticImage
                    placeholder="blurred"
                    className="w-full"
                    src="./excelent.png"
                    alt="clients"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* peoples */}
        <div className="flex justify-center pt-10">
          <div className="w-[80%]">
            <div className="w-full">
              <StaticImage
                placeholder="blurred"
                className="w-full"
                src="./clients.png"
                alt="clients"
              />
            </div>
          </div>
        </div>
        <div className="pt-4">
          <p className="whitespace-nowrap text-black lg:text-lg text-xs">
            Rated 5/5 and trusted by 3000+ businesses
          </p>
        </div>
      </div>
    </div>
  )
}
